import { cx } from "cva";
import { Body } from "~/ui-library";

type TabbedNavigationProps = {
  /**
   * A list of sibling components that will render within a ul
   *
   * THESE SHOULD ALL BE RENDERED AS AN `<li>`
   */
  children: React.ReactNode;

  /** Title of the navigation. Optional */
  title: string | undefined | null;
};

export const LandingPageTabbedNavigation = ({
  children,
  title,
}: TabbedNavigationProps) => (
  <div
    className={cx(
      "flex flex-col justify-center gap-l md:flex-row",
      "w-full max-w-[300px] text-center md:w-fit md:max-w-full md:text-start",
      "mx-auto px-m py-s md:px-l",
      "border-1 border-primary-50 bg-white"
    )}
  >
    {!!title && <Body className={cx("whitespace-nowrap")}>{title}</Body>}
    <ul className="contents">{children}</ul>
  </div>
);
